import React, { useEffect } from 'react'
import HomeCarousel from './HomeCarousel'
import AdvanceSearch from '../AdvanceSearch/AdvanceSearch'


function HeroSection() {
  return (
      <div className="relative">
        <HomeCarousel />
        <AdvanceSearch />

    </div>
  );
}

export default HeroSection;
